document.addEventListener("sections:loaded", () => {
  document.querySelectorAll(".lang-toggle").forEach((wrapper) => {
    const trigger = wrapper.querySelector("[data-lang-toggle-trigger]");
    const menu = wrapper.querySelector("[data-lang-toggle-menu]");
    if (!trigger || !menu) {
      return;
    }

    const closeMenu = () => {
      menu.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    };

    const openMenu = () => {
      menu.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    };

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      if (menu.classList.contains("is-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener("click", (event) => {
      if (!wrapper.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && menu.classList.contains("is-open")) {
        closeMenu();
        trigger.focus();
      }
    });
  });
});
